module.exports = __webpack_public_path__ + "static/media/Captain Marvel 2.e54c1417.jpg";